import { computed, type Ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { SEARCH_MODULE_ELECTIVES } from '@/graphql/Queries/moduleElectiveOfferings';
import type { SearchModuleElectivesQuery } from '@/types/operations';

export function useStudentModuleElectives(moduleId: Ref<string | null>, enabled: Ref<boolean>, query: Ref<string>) {
  const { result, loading, error, refetch } = useQuery<SearchModuleElectivesQuery>(SEARCH_MODULE_ELECTIVES,
    () => ({ moduleId: moduleId.value, query: query.value }),
    () => ({ enabled: enabled.value && !!moduleId.value, fetchPolicy: 'network-only' }));
  const courses = computed(() => enabled.value && !loading.value && result.value?.searchModuleElectiveCourses.module_id === moduleId.value
    ? result.value.searchModuleElectiveCourses.courses : []);
  return { courses, loading, error, refetch };
}
